import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const PostTypeSelect = (props) => {
	const [searchKeyword, setSearchKeyword] = useState('');

	const { postTypes, isRequesting } = useSelect(
		(select) => {
			const params = {
				per_page: -1, 
				search: searchKeyword
			};

			const excludedPostTypes = ['attachment'];

			return {
				postTypes: select('core')
					.getPostTypes(params)
					?.filter(({ viewable, slug }) => viewable && !excludedPostTypes.includes(slug)),
				isRequesting: select('core/data').isResolving('core', 'getPostTypes', [params])
			};
		},
		[searchKeyword]
	);

	const options =
		postTypes?.map((postType) => ({
			label: `${postType.name} (${postType.slug})`,
			value: postType.slug
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default PostTypeSelect;
